import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ButtonComp from "./ButtonComp";
import useMediaQuery from "../hooks/useMediaQuery";
import { Link } from "react-router-dom";
import Typography from "./Typography/Typography";
import GAlign from "./GAlign";
import Animation from "../animations/Animation";

export default function TwoColumn({ image, heading, pageName, description, buttonName, fluid, reverse, redirection, subPoints, isZoom }) {
   const lgBreakpoint = !useMediaQuery("(min-width: 991px)");
   return (
      <Container fluid={fluid}>
         <Row className={`d-flex align-items-center ${isZoom ? "isZoom" : ""}`}>
            <Col xs={12} sm={12} md={12} lg={6} xl={6} className={lgBreakpoint || reverse ? "order-2" : "order-1"}>
               <Animation fade left>
                  <>
                     <div className="mobMt20 mobMb20 zoom-img w-100">
                        <img src={image} alt={pageName} className="mobImage d-block mx-auto img-fluid" />
                     </div>
                  </>
               </Animation>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} xl={6} className={lgBreakpoint || reverse ? "order-1" : "order-2"}>
               <>
                  <span className="red-bar">{pageName}</span>
                  <Typography element="h2" syne className="fs60 pt10 pb10 tabHeadingFontSize mobSubTitle" fontWeight={600}>
                     {heading}
                  </Typography>
                  {subPoints && (
                     <GAlign className="mt25 mb15" {...(subPoints.length < 3 ? { gap: "2rem" } : { align: "between", mobalign: "between" })}>
                        {subPoints.map((points, index) => (
                           <Typography element="p" key={index} className="colorRed fs16" fontWeight={400}>
                              {points}
                              <Typography element="span" className="colorBlack dNoneXs" fontWeight={400}>
                                 --
                              </Typography>
                           </Typography>
                        ))}
                     </GAlign>
                  )}
                  <Typography element="p" className="fs16 lh28 colorMediumGrey" fontWeight={400} DMSans>
                     {description}
                  </Typography>
                  {Boolean(buttonName) && (
                     <div className="mobMt50 ml0 mt30 mb30">
                        <Link to={redirection}>
                           <ButtonComp title={buttonName} />
                        </Link>
                     </div>
                  )}
               </>
            </Col>
         </Row>
      </Container>
   );
}
